function addProduct(btn, e){
    if (btn.classList.contains('loading')) return;

    const isPopupTrigger = btn.classList.contains("variant-popup-js") || btn.querySelector(".variant-popup-js");

    btn.classList.add('loading');

    if (btn.classList.contains('disabled')) return;

    if (isPopupTrigger) {
      const productUrl = btn.dataset.vid;
      if (productUrl) {
        const url = `/products/${productUrl}?section_id=quick-add-product`;
        fetchProductDetails(url, btn, e);
      }
    } else {
      const ID = btn.getAttribute("data-product-id");
      addToCart(ID, 1, btn);
    }
}

class RenderJs {
  constructor() {
    console.log('RenderJs constructor called');
    this.init();
  }

  init() {
    console.log('RenderJs init called');
    function updatecart(url, btn) {
    fetch(url).then(function (response) {
      // The API call was successful!
      return response.text();
    }).then(function (html) {
      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      btn != "" ? btn.classList.remove("loading"): "";
      document.querySelector(".thb-secondary-cart").innerHTML = doc.querySelector(".thb-secondary-cart").innerHTML;
      document.querySelector('#Cart-Drawer').innerHTML = doc.querySelector("#Cart-Drawer").innerHTML;
      document.querySelector("#cart-drawer-toggle").click();
    }).catch(function (err) {
      // There was an error
      console.warn('Something went wrong.', err);
    }).finally(() => {
      // Remove loading class from button
      window.initProductRxcommendationsSlider();
    });
    }

    async function addToCart(productId, quantity, btn) {
      try {
          const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: productId,
                quantity: quantity,
              }),
          });

          if (!response.ok) {
            throw new Error('Error adding to cart');
          }

          const data = await response.json();
          // Display a success message
          console.log('Add to Cart Response:', data);
          updatecart('/', btn);

          //Removed active classes from popup and button
          let featureWrapper = btn.closest('.multi-variant-popup-wrapper');
          if (featureWrapper) {
            featureWrapper.classList.remove('open');
            setTimeout(() => {
              featureWrapper.classList.remove('active');
            }, 700);
            document.querySelector("html.js").style.removeProperty("overflow");
            btn.classList.remove('btn-loading');
          }
      } catch (error) {
        // Display error message
        btn.classList.remove("loading");
        console.error('Add to Cart Error:', error);
      }
    }

    document.querySelectorAll(".product-card--add-to-cart-button-simple").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Prevent double clicks
        if (btn.classList.contains('loading')) return;

        const isPopupTrigger = btn.classList.contains("variant-popup-js") || btn.querySelector(".variant-popup-js");

        btn.classList.add('loading');

        if (btn.classList.contains('disabled')) return;

        if (isPopupTrigger) {
          const productUrl = btn.dataset.vid;
          if (productUrl) {
            const url = `/products/${productUrl}?section_id=quick-add-product`;
            fetchProductDetails(url, btn, e);
          }
        } else {
          const ID = btn.getAttribute("data-product-id");
          addToCart(ID, 1, btn);
        }
      });
    });


    const fetchProductDetails = (productUrl, button, event) => {
      fetch(productUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const sectionWrapper = button.closest('.shopify-section');
        if (sectionWrapper) {
          const popupWrapper = sectionWrapper.querySelector('.multi-variant-popup-wrapper');
          const productDetails = responseHTML.querySelector('.multi-variant-popup-content');

          if (popupWrapper && productDetails) {
            const popupContent = popupWrapper.querySelector('.multi-variant-popup-content');
            if (popupContent) {
              popupContent.innerHTML = productDetails.innerHTML;

              
              document.querySelector("html.js").style.overflow = "hidden";
              popupWrapper.classList.add('active');
              
              if(productDetails.querySelectorAll('variant-radios fieldset').length > 1 || productDetails.querySelectorAll(".options-wrapper .option-list").length > 4) {
                popupWrapper.querySelector(".multi-variant-popup-inner").classList.add("fix-height-popup");
              } else {
                popupWrapper.querySelector(".multi-variant-popup-inner").classList.remove("fix-height-popup");
              }

              setTimeout(() => {
                popupWrapper.classList.add('open');
              }, 200);
              
              changeEvent(popupWrapper);
              button.classList.remove('loading');
            }
          }
        }
      })
      .catch((error) => {
        console.error('Error fetching product details:', error);
      });
    };

    const changeEvent = (data) => {
      let parent = data;
      if (!parent) {
        return;
      }
      if (document.querySelector("variant-radios input", parent)) {
        document.querySelectorAll("variant-radios input", parent).forEach(item => {
          item.addEventListener('change', (e) => {
            document.querySelectorAll('variant-radios input',parent).forEach(option => {
              option.closest('.option-list').classList.remove('selected');
            });
            document.querySelectorAll('variant-radios input:checked', parent).forEach(option => {
              option.closest('.option-list').classList.add('selected');
            });
            if(parent.querySelectorAll(".multi-variant-popup-wrapper.active.open variant-radios fieldset") && parent.querySelectorAll(".multi-variant-popup-wrapper.active.open variant-radios fieldset").length > 1) {
              variantChange(parent);
            } else {
              let addToCartBtn = parent.querySelector('.variant-quick-add-cart-js');
              let isVariantAvailable = false;
              if(item.getAttribute("is-available") == "true") {
                isVariantAvailable = true;
              }
              let price = item.getAttribute('data-price');
              addToCartBtn.setAttribute('data-price', price);
              let vId = item.getAttribute('data-vid');
              addToCartBtn.setAttribute('data-vid', vId);
              if(isVariantAvailable) {
                addToCartBtn.removeAttribute('disabled');
                addToCartBtn.querySelector(".product-card--add-to-cart-text").innerText = "ADD TO CART";
              }
              else {
                addToCartBtn.setAttribute('disabled', '');
                addToCartBtn.querySelector(".product-card--add-to-cart-text").innerText = "SOLD OUT";
              }
            }
          })
        })
      }
    };

    const variantChange = (parent) => {
      let options = [];
      let productJson = JSON.parse(document.querySelector('.product-json-js', parent).innerText);
      if (document.querySelector('variant-radios', parent)) {
        document.querySelectorAll('variant-radios input:checked', parent).forEach(option => {
          options.push(option.value);
        });
      }

      let currentVariant = productJson?.variants?.find((variant) => {
        return !variant.options.map((option, index) => {
          return options[index] === option;
        }).includes(false);
      });

      if (!currentVariant) {
        console.log('current variant not found');
        return;
      }
      
      console.log('currentVariant', currentVariant);
      let addToCartBtn = document.querySelector('.variant-quick-add-cart-js', parent);
      let isVariantAvailable = false;
      if(currentVariant?.available == true) {
        isVariantAvailable = true;
      }
      addToCartBtn.setAttribute('data-price', currentVariant?.price);
      addToCartBtn.setAttribute('data-vid', currentVariant?.id);
      if(isVariantAvailable) {
        addToCartBtn.removeAttribute('disabled');
        addToCartBtn.querySelector(".product-card--add-to-cart-text").innerText = "ADD TO CART";
      }
      else {
        addToCartBtn.setAttribute('disabled', '');
        addToCartBtn.querySelector(".product-card--add-to-cart-text").innerText = "SOLD OUT";
      }
    };

    //Close Button Click Event
    let popupCloseBtn = document.querySelectorAll('.multi-popup-close');
    if(popupCloseBtn) {
      popupCloseBtn.forEach(element => {
        element.addEventListener('click', (e) => {
          e.preventDefault();
          let that = e.currentTarget;
          let featureWrapper = that.closest('.multi-variant-popup-wrapper');
          if (featureWrapper) {
            featureWrapper.classList.remove('open');
            setTimeout(() => {
              featureWrapper.classList.remove('active');
            }, 700);
            document.querySelector("html.js").style.removeProperty("overflow");
          }
        });
      });
    }

    //Click event for Popup Add To Cart Button
    document.addEventListener('click', async (e) => {
      const atcBtn = e.target.closest('.variant-quick-add-cart-js');
      if (!atcBtn) return;

      e.preventDefault();
      e.stopPropagation();

      // Prevent multiple clicks
      if (atcBtn.classList.contains('btn-loading')) return;

      atcBtn.classList.add('btn-loading');
      atcBtn.setAttribute('disabled', 'true');

      const vId = parseInt(atcBtn.getAttribute("data-vid"), 10);

      try {
        await addToCart(vId, 1, atcBtn); // your existing function
      } catch (err) {
        console.error('Add to cart failed:', err);
      } finally {
        atcBtn.classList.remove('btn-loading');
        atcBtn.removeAttribute('disabled');
      }
    });
  }
}

// attach to window so you can call it from anywhere
window.initRenderJs = function() {
  new RenderJs();
}

// optionally call it on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  window.initRenderJs();
});


function copyToClipboard(button, code) {
    navigator.clipboard.writeText(code).then(() => {
      const wrapper = button.closest('.offer-code-wrapper');
      const message = wrapper.querySelector('.copied-message');
      message.classList.add('show');
      setTimeout(() => {
        message.classList.remove('show');
      }, 1000);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".offer-swiper", {
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      loop: false,
      breakpoints: {
        0: {
          slidesPerView: 1.5
        },
        769: {
          slidesPerView: 2
        }
      }
    });
  });

function couponupdatecart(url, btn) {
    setTimeout(() => {
      // document.querySelector(".cart-celebration").classList.remove("open");
      // btn.classList.remove("active");
    }, 4000);

    fetch(url).then(function (response) {
      // The API call was successful!
      return response.text();
    }).then(function (html) {
      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      setTimeout(() => {
      document.querySelector(".thb-secondary-cart").innerHTML = doc.querySelector(".thb-secondary-cart").innerHTML;
      document.querySelector('#Cart-Drawer').innerHTML = doc.querySelector("#Cart-Drawer").innerHTML;
    }, 2000);
      
    }).catch(function (err) {
      // There was an error
      console.warn('Something went wrong.', err);
    }).finally(() => {
      // Remove loading class from button
      window.initProductRxcommendationsSlider();
    });
    }


  function updateCartSavings(btn) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // cart.total_price = final amount in paise (after discount)
        // cart.original_total_price = original price without discounts (only available in some themes)
        // If not available, we sum up line item prices * quantity

        let originalTotal = 0;
        cart.items.forEach(item => {
          // Price without discount is original_line_price (if available) else compare_at_price
          let originalLinePrice = item.original_price ? item.original_price * item.quantity : item.line_price;
          originalTotal += originalLinePrice;
        });

        let currentTotal = cart.total_price;

        let savings = originalTotal - currentTotal;

        // Only update if there are savings
        if (savings > 0) {
          let formattedSavings = (savings / 100).toLocaleString('en-IN', { minimumFractionDigits: 2 });
          document.querySelector('.savedprice').textContent = `You saved ₹${formattedSavings}`;
          document.querySelector('.total_saving').textContent = `Total saving ₹${formattedSavings}`;
        }

        
        document.querySelector(".cart-celebration").classList.add("open");
        couponupdatecart('/', btn);
      });
  }

function applyCoupon(code, btn){
  btn.classList.add("active");
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ discount: code }),
  })
    .then((res) => {
      closeCouponDrawer();
      
      
      var hascode = document.querySelector(".apply_btn span");
      if (hascode && hascode.textContent != 'Remove') {
        updateCartSavings(btn);
      }else{
        couponupdatecart('/', btn);
      }
      
      var data = res.json()
      return;
    })
    .then((data) => {
      const failed = data.discount_codes?.find((d) => d.code === code && !d.applicable);
      if (failed) {
        return;
      }
    })
    .catch((err) => {
      
    });
}

function openCouponDrawer(){
  document.querySelector(".cart-promotion-drawer__wrapper").classList.add("open");
}

function closeCouponDrawer(){
  document.querySelector(".cart-promotion-drawer__wrapper").classList.remove("open");
}

document.addEventListener("DOMContentLoaded", function () {
    const embeds = document.querySelectorAll(".youtube-embed-code");

    embeds.forEach((div) => {
      const youtubeUrl = div.dataset.url;
      const videoId = youtubeUrl.includes("v=")
        ? youtubeUrl.split("v=")[1].split("&")[0]
        : youtubeUrl.split("/").pop();

      const iframe = document.createElement("iframe");
      iframe.src = `https://www.youtube.com/embed/${videoId}`;
      iframe.allow =
        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
      iframe.allowFullscreen = true;

      div.innerHTML = ""; // clear existing content
      div.appendChild(iframe);
    });
  });


  document.querySelectorAll(".write-review-button").forEach(function(review){
    review.addEventListener("click", function(){
      this.closest(".order-details").querySelector(".collaps-order-details").classList.toggle("active");
    })
  })

  document.querySelectorAll(".view-order-button").forEach(function(review){
    review.addEventListener("click", function(){
      this.closest(".order-details").querySelector(".collaps-order-details").classList.toggle("active");
    })
  })

  const reorderButtons = document.querySelectorAll(".reorder-button");

  reorderButtons.forEach((button) => {
    button.addEventListener("click", async function (e) {
      e.preventDefault();
      var btn = this;
      btn.classList.add("active");
      let lineItems = JSON.parse(button.getAttribute("data-line-items"));

      // Add each line item back to cart
      for (let item of lineItems) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: item.variant_id,
            quantity: item.quantity,
          }),
        });
      }

      // ✅ Option 1: Redirect to cart page
      couponupdatecart('/', btn);

      setTimeout(() => {
        document.querySelector("#cart-drawer-toggle").click();
      }, 2000);

      // ✅ Option 2: If you want to open cart drawer instead:
      // document.dispatchEvent(new CustomEvent("theme:cart:change", { bubbles: true }));
    });
  });

  document.querySelectorAll(".add-new-address-card").forEach(function(newaddress){
    newaddress.addEventListener("click", function(){
      const addressBox = this.closest(".address-details");
      addressBox.querySelector(".address-container").classList.add("d-none");
      addressBox.querySelector(".address-form-container").classList.remove("d-none");
      const form = addressBox.querySelector("#address_form_new");
      form.setAttribute("action", "/account/addresses");

      // Remove _method if present
      const methodInput = form.querySelector("input[name='_method']");
      if (methodInput) methodInput.remove();

      const formTitle = addressBox.querySelector(".address-form-title");

      formTitle.textContent = "Add New Address";
      form.querySelector("[name='address[first_name]']").value = "";
      form.querySelector("[name='address[last_name]']").value = "";
      form.querySelector("[name='address[company]']").value = "";
      form.querySelector("[name='address[address1]']").value = "";
      form.querySelector("[name='address[address2]']").value = "";
      form.querySelector("[name='address[city]']").value = "";
      form.querySelector("[name='address[zip]']").value = "";
      form.querySelector("[name='address[phone]']").value = "";

      form.scrollIntoView({ behavior: "smooth" });
    })
  })

  document.querySelectorAll(".address-cancel-btn").forEach(function(newaddress){
    newaddress.addEventListener("click", function(){
      this.closest(".address-details").querySelector(".address-container").classList.remove("d-none");
      this.closest(".address-details").querySelector(".address-form-container").classList.add("d-none");
    })
  })

  

document.querySelectorAll("#address_form_new").forEach(function(address){
  address.addEventListener("submit", async function(e) {
    e.preventDefault();
    var action = this.getAttribute("action");
    const formData = new FormData(this);

    try {
      let res = await fetch(action, {
        method: "POST",
        body: formData,
      });

      if (res.ok) {
        alert("Address added successfully!");
        window.location.reload(); // reload to show new address
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error(err);
      alert("Error adding address.");
    }
  });
})

document.querySelectorAll(".address-remove-btn").forEach(btn => {
    btn.addEventListener("click", async function(e) {
      e.preventDefault();

      const addressId = this.dataset.id;
      if (!confirm("Are you sure you want to delete this address?")) return;

      try {
        let res = await fetch(`/account/addresses/${addressId}`, {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest"
          },
          body: new URLSearchParams({
            _method: "delete",     // Shopify expects this
            form_type: "customer_address",
            utf8: "✓"
          })
        });

        if (res.ok) {
          alert("Address deleted successfully!");
          window.location.reload(); // Refresh list
        } else {
          alert("Failed to delete address.");
        }
      } catch (err) {
        console.error(err);
        alert("Error deleting address.");
      }
    });
  });

  const editButtons = document.querySelectorAll(".address-edit-btn");

  // --- Handle Edit Click ---
  editButtons.forEach(btn => {
    btn.addEventListener("click", function () {
      const addressBox = this.closest(".address-details");
      addressBox.querySelector(".address-container").classList.add("d-none");
      addressBox.querySelector(".address-form-container").classList.remove("d-none");
      const form = addressBox.querySelector("#address_form_new");
      const formTitle = addressBox.querySelector(".address-form-title");
      // const addressIdInput = addressBox.querySelector("#address_id");
      const id = this.dataset.id;
      const indivisualaddress= this.closest(".address-inner");

      

      // Split name into first + last
      const name = indivisualaddress.querySelector(".address-name")?.innerText.split(" ");
      const firstName = name[0] || "";
      const lastName = name.slice(1).join(" ") || "";

      // Extract values
      const company = indivisualaddress.querySelector(".company-name")?.innerText || "";
      const address1 = indivisualaddress.querySelector(".address1-line")?.innerText || "";
      const address2 = indivisualaddress.querySelector(".address2-line")?.innerText || "";
      const city = indivisualaddress.querySelector(".city-details")?.innerText || "";
      const country = indivisualaddress.querySelector(".country-name")?.innerText || "";
      const phone = indivisualaddress.querySelector(".phone-number")?.innerText || "";
      const zip = indivisualaddress.querySelector(".zipcode")?.innerText || "";
      const province = indivisualaddress.querySelector(".province-details")?.innerText || "";

      // Fill the form fields
      form.querySelector("[name='address[first_name]']").value = firstName;
      form.querySelector("[name='address[last_name]']").value = lastName;
      form.querySelector("[name='address[company]']").value = company;
      form.querySelector("[name='address[address1]']").value = address1;
      form.querySelector("[name='address[address2]']").value = address2;
      form.querySelector("[name='address[city]']").value = city;
      form.querySelector("[name='address[country]']").value = country;
      form.querySelector("[name='address[zip]']").value = zip;
      form.querySelector("[name='address[phone]']").value = phone;
      form.querySelector("[name='address[province]']").value = province;
      

      // Hidden ID field
      // addressIdInput.value = id;

      // Change form action to update
      form.setAttribute("action", `/account/addresses/${id}`);

      // Add method override for PUT
      if (!form.querySelector("input[name='_method']")) {
        let methodInput = document.createElement("input");
        methodInput.type = "hidden";
        methodInput.name = "_method";
        methodInput.value = "put";
        form.appendChild(methodInput);
      }

      // Update title
      formTitle.textContent = "Edit Address";

      // Scroll into view
      form.scrollIntoView({ behavior: "smooth" });
    });
  });

async function addAddress(action, formData) {
  try {
    let res = await fetch(action, {
      method: "POST",
      body: formData,
    });

    if (res.ok) {
      alert("Address added successfully!");
      window.location.reload(); // reload to show new address
    } else {
      let text = await res.text();
      console.error("Error Response:", text);
      alert("Something went wrong. Please try again.");
    }
  } catch (err) {
    console.error(err);
    alert("Error adding address.");
  }
}


document.querySelectorAll(".address-default-btn").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const addressBox = btn.closest(".address-details");
      const form = addressBox.querySelector("#address_form_new");
      const formTitle = addressBox.querySelector(".address-form-title");
      // const addressIdInput = addressBox.querySelector("#address_id");
      const id = btn.dataset.id;
      const indivisualaddress= btn.closest(".address-inner");

      

      // Split name into first + last
      const name = indivisualaddress.querySelector(".address-name")?.innerText.split(" ");
      const firstName = name[0] || "";
      const lastName = name.slice(1).join(" ") || "";

      // Extract values
      const company = indivisualaddress.querySelector(".company-name")?.innerText || "";
      const address1 = indivisualaddress.querySelector(".address1-line")?.innerText || "";
      const address2 = indivisualaddress.querySelector(".address2-line")?.innerText || "";
      const city = indivisualaddress.querySelector(".city-details")?.innerText || "";
      const country = indivisualaddress.querySelector(".country-name")?.innerText || "";
      const phone = indivisualaddress.querySelector(".phone-number")?.innerText || "";
      const zip = indivisualaddress.querySelector(".zipcode")?.innerText || "";
      const province = indivisualaddress.querySelector(".province-details")?.innerText || "";

      // Fill the form fields
      form.querySelector("[name='address[first_name]']").value = firstName;
      form.querySelector("[name='address[last_name]']").value = lastName;
      form.querySelector("[name='address[company]']").value = company;
      form.querySelector("[name='address[address1]']").value = address1;
      form.querySelector("[name='address[address2]']").value = address2;
      form.querySelector("[name='address[city]']").value = city;
      form.querySelector("[name='address[country]']").value = country;
      form.querySelector("[name='address[zip]']").value = zip;
      form.querySelector("[name='address[phone]']").value = phone;
      form.querySelector("[name='address[province]']").value = province;
      form.querySelector("#address_default").checked = true
      

      // Hidden ID field
      // addressIdInput.value = id;

      // Change form action to update
      form.setAttribute("action", `/account/addresses/${id}`);

      // Add method override for PUT
      if (!form.querySelector("input[name='_method']")) {
        let methodInput = document.createElement("input");
        methodInput.type = "hidden";
        methodInput.name = "_method";
        methodInput.value = "put";
        form.appendChild(methodInput);
      }

      // Update title
      formTitle.textContent = "Edit Address";

      // Scroll into view
      form.scrollIntoView({ behavior: "smooth" });

      var action = form.getAttribute("action");
      const formData = new FormData(form);
      addAddress(action, formData)
    });
  });


  document.querySelectorAll(".address-remove-btn").forEach((btn) => {
    btn.addEventListener("click", async function () {
      btn.setAttribute("disabled", "disabled")
      let id = this.dataset.id;

      if (!confirm("Are you sure you want to delete this address?")) return;

      try {
        let res = await fetch(`/account/addresses/${id}`, {
          method: "DELETE",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
          },
        });

        if (res.ok) {
          alert("Address removed successfully!");
          window.location.reload(); // refresh page to update list
        } else {
          alert("Failed to remove address. Please try again.");
        }
      } catch (err) {
        console.error("Error:", err);
        alert("Something went wrong while removing address.");
      }
    });
  });


const groups = document.querySelectorAll(".order-group"); // All order groups
  const paginationItems = document.querySelectorAll(".pagination-li"); // All pagination li
  const prevBtn = document.querySelector(".prev-btn");
  const nextBtn = document.querySelector(".next-btn");
  let currentIndex = 0; // Start from first page (0-based)

  // Function to update visible group
  function showGroup(index) {
    groups.forEach((group, i) => {
      if (i === index) {
        group.classList.remove("d-none");
      } else {
        group.classList.add("d-none");
      }
    });

    paginationItems.forEach((item, i) => {
      if (i === index) {
        item.classList.add("active");
      } else {
        item.classList.remove("active");
      }
    });

    // Disable/Enable Prev/Next buttons
    prevBtn ? prevBtn.disabled = index === 0: "";
    nextBtn ? nextBtn.disabled = index === groups.length - 1: "";
  }

  // Pagination number click
  paginationItems.forEach((item, i) => {
    item.addEventListener("click", function () {
      currentIndex = i;
      showGroup(currentIndex);
    });
  });

  // Prev button click
  prevBtn ? prevBtn.addEventListener("click", function () {
    if (currentIndex > 0) {
      currentIndex--;
      showGroup(currentIndex);
    }
  }): "";

  // Next button click
  nextBtn ? nextBtn.addEventListener("click", function () {
    if (currentIndex < groups.length - 1) {
      currentIndex++;
      showGroup(currentIndex);
    }
  }): "";

  // Show first group by default
  showGroup(currentIndex);


let swiperInstance = null;
  const breakpoint = 768; // Mobile breakpoint

  function initSwiper() {
    if (window.innerWidth < breakpoint && !swiperInstance) {
      document.querySelector(".menu-list-box")?document.querySelector(".menu-list-box").classList.add("swiper"): "";
      document.querySelector(".menu-items")?document.querySelector(".menu-items").classList.add("swiper-wrapper"): "";
      document.querySelectorAll(".menu-item").forEach(function(menu){
        menu.classList.add("swiper-slide")
      });
      swiperInstance = new Swiper(".menu-list-box", {
        slidesPerView: 4,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    } else if (window.innerWidth >= breakpoint && swiperInstance) {
      document.querySelector(".menu-list-box")?document.querySelector(".menu-list-box").classList.remove("swiper"): "";
      document.querySelector(".menu-items")?document.querySelector(".menu-items").classList.remove("swiper-wrapper"): "";
       document.querySelectorAll(".menu-item").forEach(function(menu){
        menu.classList.remove("swiper-slide")
      });
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  // Initialize on load
  initSwiper();

  // Re-check on resize
  window.addEventListener("resize", initSwiper);

  if(window.location.href.includes('/pages/tracking-page?')){
    var id = window.location.href.split("?orderid=")[1];
    document.querySelector(".dev_ref_id").value = id;
  }


  const swiperEl = document.querySelector(".mega-menu-swiper");

  
  

  const swiper = new Swiper('.mega-menu-swiper', {
    slidesPerView: 5,
    spaceBetween: 10,

    // built-in touch/mouse settings
    simulateTouch: true,
    grabCursor: true,
    threshold: 5,
    touchRatio: 1,
    touchAngle: 45,
    followFinger: true,

    // Enable Swiper mousewheel module (works if touchpad emits wheel)
    mousewheel: {
      forceToAxis: true,    // prefer horizontal axis when scroll is horizontal
      sensitivity: 1,
      releaseOnEdges: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  // ---------- 1) Robust wheel fallback (accumulate small deltas) ----------
  let wheelAccum = 0;
  let wheelTimer = null;
  const WHEEL_THRESHOLD = 40; // tune this: smaller = more sensitive

  function handleWheelForSwiper(e) {
    // Only consider mostly-horizontal gestures
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    e.preventDefault(); // prevent page horizontal scroll

    // accumulate deltaX (some devices send very small values)
    wheelAccum += e.deltaX;

    // reset after short pause
    clearTimeout(wheelTimer);
    wheelTimer = setTimeout(() => { wheelAccum = 0; }, 80);

    if (Math.abs(wheelAccum) >= WHEEL_THRESHOLD) {
      if (wheelAccum > 0) swiper.slideNext();
      else swiper.slidePrev();
      wheelAccum = 0;
    }
  }

  // older event names included for wider browser coverage
  swiperEl.addEventListener('wheel', handleWheelForSwiper, { passive: false });
  swiperEl.addEventListener('mousewheel', handleWheelForSwiper, { passive: false });

  // ---------- 2) Pointer fallback for desktop drag (non-wheel trackpads) ----------
  let pointerDown = false;
  let pointerStartX = 0;
  const POINTER_THRESHOLD = 60; // px to trigger slide

  swiperEl.addEventListener('pointerdown', (e) => {
    // Only left button or touch/pointer
    pointerDown = true;
    pointerStartX = e.clientX;
  });
  swiperEl.addEventListener('pointermove', (e) => {
    if (!pointerDown) return;
    const diff = e.clientX - pointerStartX;
    if (Math.abs(diff) >= POINTER_THRESHOLD) {
      if (diff < 0) swiper.slideNext();
      else swiper.slidePrev();
      pointerDown = false;
    }
  });
  ['pointerup', 'pointercancel', 'pointerleave'].forEach(ev => {
    swiperEl.addEventListener(ev, () => pointerDown = false);
  });

  // ---------- 3) Touch fallback for mobile (if needed) ----------
  let touchStartX = null;
  const TOUCH_THRESHOLD = 50;
  swiperEl.addEventListener('touchstart', (e) => {
    touchStartX = e.touches ? e.touches[0].clientX : null;
  }, { passive: true });
  swiperEl.addEventListener('touchmove', (e) => {
    if (touchStartX === null) return;
    const curX = e.touches[0].clientX;
    const diff = curX - touchStartX;
    if (Math.abs(diff) > TOUCH_THRESHOLD) {
      if (diff < 0) swiper.slideNext();
      else swiper.slidePrev();
      touchStartX = null;
    }
  }, { passive: true });
  swiperEl.addEventListener('touchend', () => touchStartX = null);


  function closeQuickAdd(that){
      let featureWrapper = that.closest('.multi-variant-popup-wrapper');
      if (featureWrapper) {
        featureWrapper.classList.remove('open');
        setTimeout(() => {
          featureWrapper.classList.remove('active');
        }, 700);
        document.querySelector("html.js").style.removeProperty("overflow");
      }
  }